export enum Gender {
  Male = 'male',
  Female = 'female',
  Other = 'other',
}

export enum HeartRateStep {
  CAPTURE_METRIC_INFO = 'CaptureMetricInfo',
  CAPTURE_BELT = 'CaptureHeartRateBeltNumber',
  HAS_BELT = 'HasHeartRateMonitor',
  TEST_BELT = 'TestHeartRateBelt',
  FAQ = 'Faq',
}

export interface Instructor {
  id: string;
  name: string;
  avatar: string;
  avatarUrl: string;
  isActive: boolean;
}

export interface ILogger {
  debug: (message: string) => void;
  info: (message: string) => void;
  warn: (message: string) => void;
  error: (message: string) => void;
}

export enum RemoteConfigVariables {
  welcome_screen_version = 'welcome_screen_version',
  welcome_screen_heading = 'welcome_screen_heading',
  welcome_screen_sub_heading = 'welcome_screen_sub_heading',
  onboarding_screen_version = 'onboarding_screen_version',
  signup_auth_screen_version = 'signup_auth_screen_version',
  signup_post_auth_action = 'signup_post_auth_action',
  signup_initial_plan_id = 'signup_initial_plan_id',
  signup_screen_version = 'signup_screen_version',
  welcome_screen_register_button = 'welcome_screen_register_button',
  welcome_screen_login_button = 'welcome_screen_login_button',
  create_account_screen_heading = 'create_account_screen_heading',
  create_account_screen_sub_heading = 'create_account_screen_sub_heading',
  in_app_purchase_screen_product_description = 'in_app_purchase_screen_product_description',
  in_app_purchase_screen_benefit = 'in_app_purchase_screen_benefit',
  in_app_purchase_close_modal_sub_header = 'in_app_purchase_close_modal_sub_header',
  iap_hub_product_id_fitillion = 'iap_hub_product_id_fitillion',
  paywall_heading_text = 'paywall_heading_text',
  paywall_payment_text = 'paywall_payment_text',
  smart_scale_shop_url = 'smart_scale_shop_url',
  tigernovo_heart_rate_shop_url = 'tigernovo_heart_rate_shop_url',
  learn_more_about_nutrition_button_visible = 'learn_more_about_nutrition_button_visible',
  enable_first_time_booking_instant_workout = 'enable_first_time_booking_instant_workout',
  free_trial_days = 'free_trial_days',
}

export interface IZoneServerVersioning {
  configDate: string;
}
